import { Skeleton } from "@mui/material";
import { type FC } from "react";

import { EmbedSparklineSkeleton } from "~/feature/embed/components/EmbedSparkline";

import * as Styled from "./EmbedCard.styles";

const ODDS_ROWS = [0, 1, 2, 3];

interface IEmbedCardSkeletonProps {
  border: boolean;
}

export const EmbedCardSkeleton: FC<IEmbedCardSkeletonProps> = ({ border }) => (
  <Styled.Root $border={border}>
    <Styled.Header>
      <Skeleton variant="circular" width={28} height={28} />
      <Skeleton variant="text" width="65%" height={20} />
    </Styled.Header>

    <EmbedSparklineSkeleton />

    <Styled.Odds $columns={2}>
      {ODDS_ROWS.map((row) => (
        <Styled.Row key={row} $consensus={false} />
      ))}
    </Styled.Odds>

    <Styled.Footer>
      <Skeleton variant="text" width={72} height={16} />
      <Styled.Branding>
        <Skeleton variant="text" width={132} height={14} />
      </Styled.Branding>
    </Styled.Footer>
  </Styled.Root>
);
